import { useToasts } from "react-toast-notifications";
import { useContent } from "../../../../contexts/contentContext/contentContext";
import { useUser } from "../../../../contexts/userContext/userContext";
import type { BillingDetailsT } from "../../../../models/models";
import checkChangePayMethodAllowed from "../helpers/checkChangePayMethodAllowed";
import getCorrectBillingMethod from "../helpers/getCorrectBillingMethod";

const useChangePaymentMethodCheck = () => {
  const { getUserBillingDetails } = useUser();
  const billingDetails = getUserBillingDetails() as BillingDetailsT;
  const isAllowedToChange = checkChangePayMethodAllowed(
    billingDetails?.auto_renew,
    billingDetails?.token_id,
    billingDetails?.provider_id
  );
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();

  const checkIfChangePayMethodAllowed = (purchasePaymentMethod: string) => {
    // Allow to change payment method if it's a new user with no payment history
    if (!billingDetails) {
      return true;
    }

    if (!billingDetails?.payment_gateway) {
      return true;
    }

    const billingMethod = getCorrectBillingMethod(
      billingDetails?.payment_gateway
    );
    if (billingMethod) {
      if (
        // If user wants to change payment method (new method not the same as the current one)
        billingMethod?.toLowerCase() !== purchasePaymentMethod?.toLowerCase()
      ) {
        // Check if it's allowed
        if (!isAllowedToChange) {
          addToast(getTextByKey("cannot-change-payment-method"), {
            appearance: "error",
          });
        }
        return isAllowedToChange;
      } else {
        return true;
      }
    }
  };

  return { checkIfChangePayMethodAllowed };
};

export default useChangePaymentMethodCheck;
